(function(window, timeFormatterDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.timeFormatter = timeFormatterDefinition();
})(this, function() {
   'use strict';

   var padIfNecessary = function(num) {
      return num >= 10 ? num : '0' + num;
   };

   var formatTime = function(totalSeconds) {
      totalSeconds = Math.round(totalSeconds);
      var hoursPlace = Math.floor(totalSeconds / 3600);
      var secondsWithoutHours = totalSeconds % 3600;
      var minutesPlace = Math.floor(secondsWithoutHours / 60);
      var secondsPlace = secondsWithoutHours % 60;

      if (hoursPlace > 0) {
         return hoursPlace + ':' + padIfNecessary(minutesPlace) + ':' + padIfNecessary(secondsPlace);
      } else if (minutesPlace > 0) {
         return minutesPlace + ':' + padIfNecessary(secondsPlace);
      }
      return '0:' + padIfNecessary(secondsPlace);
   };

   return {
      /**
       *  Utility function for formatting a number seconds into a user-readable duration
       *  @function formatTime
       *  @memberof TSC.timeFormatter
       *  @static
       *  @param {Number} totalSeconds - numbers of seconds to format
       *  @returns {String} seconds formated as 00:00
       */
      formatTime: formatTime
   };
});

